<template>
  <div v-if="mode">
    <comment :element-uuid="element.uuid" :submission-uuid="main_sid" />
    <h5 class="text-left" v-if="saveData.label">{{saveData.label | token_replace(nid)}}</h5>
    <md-field :class="messageClass">
      <md-textarea
        :maxlength="saveData.counter_type === 'character' ? saveData.maxlength : ''"
        v-model="saveData.value"
        :required="saveData.required === true && pmode != true ? 'required' : null"
      ></md-textarea>
      <span class="md-helper-text">{{ saveData.help_text | token_replace(nid)}}</span>
      <span class="md-error">{{ this.errorText }}</span>
      <span class="md-counter"> {{ saveData.counter_type === 'character' ? this.currentCharacters : this.currentWords }}/ {{ saveData.counter }}</span>
    </md-field>
  </div>
  <md-card v-else class="md-elevation-2 md-layout-item">
    <fb-controll
      :controll="saveData.label || 'TextArea'"
      @collapse-click="collapsePreview"
      @setting-click="showSettings"
      @menu-delete="$emit('menu-delete')"
    />
    <md-content v-show="!collapse">
      <md-field>
        <label>{{tempData.label}}<span v-if="tempData.required">*</span></label>
        <md-textarea
          :maxlength="tempData.counter_type === 'character' ? tempData.maxlength : ''"
          v-model="tempData.value"
        ></md-textarea>
        <span class="md-helper-text">{{ tempData.help_text | token_replace(nid)}}</span>
        <span class="md-error">{{ this.errorText }}</span>
        <span class="md-counter"> {{ tempData.counter_type === 'character' ? this.currentCharactersTemp : this.currentWordsTemp }}/{{ tempData.counter }}</span>
      </md-field>
    </md-content>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Settings</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Label</label>
          <md-input v-model="tempData.label"></md-input>
        </md-field>
        <md-field>
          <label>Help Text</label>
          <md-input v-model="tempData.help_text"></md-input>
        </md-field>
        <md-field>
          <label>Value</label>
          <md-input v-model="tempData.value"></md-input>
        </md-field>
        <md-field>
          <label>Counter Type</label>
          <md-select v-model="tempData.counter_type">
            <md-option value="character">Characters</md-option>
            <md-option value="word">Words</md-option>
          </md-select>
        </md-field>
        <md-field>
          <label>Counter minimum</label>
          <md-input v-model="tempData.counter_min"></md-input>
        </md-field>
        <md-field>
          <label>Counter maximum</label>
          <md-input v-model="tempData.counter"></md-input>
        </md-field>
        <md-checkbox v-model="tempData.required">Required</md-checkbox>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cancel">Close</md-button>
        <md-button class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import FbElementMixin from "./FbElementMixin";

export default {
  name: "FbTextArea",
  props: ["element", "mode", "validate", "pmode"],
  mixins: [FbElementMixin],
  created() {
    if (
      this.sid &&
      this.sid != "" &&
      window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
        this.element.uuid
      ]
    ) {
      this.saveData.value =
        window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
          this.element.uuid
        ].value;
      this.$emit("set-value", this.value);
    }
    this.$emit("validation", this.valid);
  },
  mounted() {
    $(this.$el).find('textarea.md-textarea').attr('aria-label', this.saveData.label);
  },
  computed: {
    messageClass() {
      return {
        "md-invalid": !this.valid && this.validate === true
      };
    },
    valid() {
      if (this.isDraft) {
        return true;
      }
      if (!this.checkRequired()) {
        return false;
      }
      return this.checkMinCount() && this.checkMaxCount();
    },
    value() {
      return {
        uuid: this.element.uuid,
        label: this.saveData.label,
        value: this.saveData.value,
        type: this.element.type
      };
    },
    currentCharactersTemp() {
      return this.tempData.value.length;
    },
    currentWordsTemp() {
      let words = this.tempData.value.split(/[\t\s]/).filter(item => !!item);
      return words.length;
    },
    currentCharacters() {
      return this.saveData.value.length;
    },
    currentWords() {
      let words = this.saveData.value.split(/[\t\s]/).filter(item => !!item);
      return words.length;
    }
  },
  methods: {
    checkRequired() {
      this.errorText = '*Required.';
      return !(this.saveData.required === true && this.saveData.value == "");
    },
    checkMinCount() {
      if (this.isDraft) {
        return true;
      }
      let result = false;
      if (+this.saveData.counter_min === 0) {
        return true;
      }
      if (this.saveData.counter_type === 'character') {
        result = this.currentCharacters >= +this.saveData.counter_min;
      }
      if (this.saveData.counter_type === 'word') {
        result = this.currentWords >= +this.saveData.counter_min;
      }
      if (!result) {
        this.errorText = `*Response must meet minimum ${this.saveData.counter_min} ${this.saveData.counter_type} count.`;
      }
      return result;
    },
    checkMaxCount() {
      //if (this.isDraft) {
      //  return true;
      //}

      let result = true;
      if (+this.saveData.counter === 0) {
       return true;
      }

      // Cut result text.
      if (this.saveData.counter_type === 'character' && this.currentCharacters >= +this.saveData.counter) {
        this.saveData.value = this.saveData.value.slice(0, +this.saveData.counter);
        this.saveData.maxlength = this.saveData.counter;
      }
      if (this.saveData.counter_type === 'word') {
        if (this.currentWords > +this.saveData.counter) {
          let words = this.saveData.value.split(/[\t\s]/);
          words.splice(+this.saveData.counter, +this.currentWords);
          this.saveData.value = words.join(' ');
          this.tempData.value = words.join(' ');
        }
      }
      return result;
    }
  },
  data() {
    return {
      tempData: {
        label: this.element.data.label || "",
        value: this.element.data.value || "",
        counter_type: this.element.data.counter_type || "character",
        counter_min: this.element.data.counter_min === undefined ? "0" : this.element.data.counter_min,
        counter: this.element.data.counter === undefined ? "500" : this.element.data.counter,
        help_text: this.element.data.help_text || "",
        required: this.element.data.required || "",
        maxlength: this.element.data.counter
      },
      saveData: {
        label: this.element.data.label || "",
        value: this.element.data.value || "",
        counter_type: this.element.data.counter_type || "character",
        counter_min: this.element.data.counter_min === undefined ? "0" : this.element.data.counter_min,
        counter: this.element.data.counter === undefined ? "500" : this.element.data.counter,
        help_text: this.element.data.help_text || "",
        required: this.element.data.required || "",
        maxlength: this.element.data.counter
      },
      errorText: '*Required.',
    };
  },
  watch: {
    "saveData.value": function value() {
      this.checkMinCount();
      this.checkMaxCount();
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.text-area-label {
  left: 0;
  top: 0;
  padding: 16px;
}
.md-counter {
  height: 20px;
  position: absolute;
  font-size: 12px;
  transition: .3s cubic-bezier(.4,0,.2,1);
  color: rgba(0, 0, 0, 0.54);
  right: 6px;
  bottom: 2px;
}
</style>
<style lang="scss">
  .md-count {
    display: none;
  }
</style>
